
<!-- Login Page -->
<div class="min-h-screen bg-gradient-to-br from-purple-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center px-4 sm:px-6 lg:px-8 relative overflow-hidden">
  
  <!-- Background Decorations -->
  <div class="absolute inset-0 overflow-hidden pointer-events-none">
    <div class="absolute -top-40 -right-40 w-80 h-80 bg-purple-200 dark:bg-purple-900/20 rounded-full mix-blend-multiply dark:mix-blend-overlay filter blur-xl opacity-70 animate-pulse"></div>
    <div class="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-200 dark:bg-indigo-900/20 rounded-full mix-blend-multiply dark:mix-blend-overlay filter blur-xl opacity-70 animate-pulse animation-delay-2000"></div>
    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-200 dark:bg-pink-900/10 rounded-full mix-blend-multiply dark:mix-blend-overlay filter blur-xl opacity-50 animate-pulse animation-delay-4000"></div>
  </div>

  <!-- Welcome Image - Hidden on mobile, visible on larger screens -->
  <div class="hidden lg:block absolute bottom-8 left-8">
    <div class="group relative">
      <a href="/landing" class="block">
        <img class="w-64 xl:w-80 drop-shadow-2xl group-hover:scale-105 transition-transform duration-300" src="assets/draw.png" alt="Welcome illustration"/>
      </a>
      <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div class="bg-black/80 text-white px-4 py-2 rounded-lg font-mono text-sm backdrop-blur-sm">
          Bienvenido a Tu Lugar Seguro 💜
        </div>
      </div>
    </div>
  </div>

  <!-- Main Login Container -->
  <div class="w-full max-w-md relative z-10">
    <!-- Header -->
    <div class="text-center mb-8">
      <div class="flex items-center justify-center mb-6">
        <div class="bg-white dark:bg-slate-800 p-3 rounded-full shadow-lg ring-1 ring-purple-100 dark:ring-purple-900/50">
          <img class="w-12 h-12" src="assets/logodr.png" alt="ReliefApp Logo" />
        </div>
      </div>
      <h1 class="font-mono text-4xl sm:text-5xl text-purple-600 dark:text-purple-400 mb-2">ReliefApp</h1>
      <p class="font-mono text-slate-600 dark:text-slate-300 text-lg">Tu lugar seguro</p>
    </div>

    <!-- Login Card -->
    <div class="bg-white/80 dark:bg-slate-800/80 backdrop-blur-lg shadow-2xl rounded-2xl border border-white/20 dark:border-slate-700/50 overflow-hidden">
      <div class="px-8 py-10">
        <!-- Welcome Message -->
        <div class="text-center mb-8">
          <h2 class="font-mono text-xl text-slate-800 dark:text-slate-200 mb-2">¡Bienvenido de vuelta!</h2>
          <p class="font-mono text-sm text-slate-500 dark:text-slate-400">Inicia sesión para acceder a tu espacio seguro</p>
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="mb-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-4">
          <div class="flex items-start">
            <svg class="w-5 h-5 text-red-600 dark:text-red-400 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
            <p class="font-mono text-sm text-red-800 dark:text-red-200">{{ errorMessage }}</p>
          </div>
        </div>

        <!-- Google Login Button -->
        <button 
          (click)="onLoginGoogle()" 
          [disabled]="isLoading"
          type="button" 
          class="w-full bg-white dark:bg-slate-700 hover:bg-gray-50 dark:hover:bg-slate-600 border border-gray-300 dark:border-slate-600 rounded-xl px-6 py-4 flex items-center justify-center space-x-3 transition-all duration-200 shadow-lg hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-purple-500/20 group disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-slate-700">
          
          <!-- Loading Spinner -->
          <svg *ngIf="isLoading" class="animate-spin w-6 h-6 text-purple-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>

          <!-- Google Icon -->
          <svg *ngIf="!isLoading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" class="w-6 h-6 flex-shrink-0">
            <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path>
            <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path>
            <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path>
            <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
          </svg>
          
          <span class="font-mono text-gray-700 dark:text-gray-200 font-medium group-hover:text-gray-900 dark:group-hover:text-white transition-colors">
            {{ isLoading ? 'Iniciando sesión...' : 'Continuar con Google' }}
          </span>
          
          <svg *ngIf="!isLoading" class="w-5 h-5 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 group-hover:translate-x-1 transition-all duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>

        <!-- Features Preview -->
        <div class="mt-8 pt-6 border-t border-gray-200 dark:border-slate-700">
          <p class="text-xs font-mono text-slate-500 dark:text-slate-400 mb-4 text-center">¿Por qué ReliefApp?</p>
          <div class="grid grid-cols-2 gap-4">
            <div class="text-center">
              <div class="bg-green-100 dark:bg-green-900/30 w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2">
                <svg class="w-4 h-4 text-green-600 dark:text-green-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                </svg>
              </div>
              <p class="font-mono text-xs text-slate-600 dark:text-slate-300">Totalmente<br>Privado</p>
            </div>
            <div class="text-center">
              <div class="bg-purple-100 dark:bg-purple-900/30 w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2">
                <svg class="w-4 h-4 text-purple-600 dark:text-purple-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
              </div>
              <p class="font-mono text-xs text-slate-600 dark:text-slate-300">Lugar<br>Seguro</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Links -->
    <div class="mt-8 text-center space-y-4">
      <!-- Privacy Policy Link -->
      <div>
        <app-privacy-link 
          [linkText]="'Aviso de Privacidad'" 
          [customClass]="'text-sm font-mono text-slate-500 dark:text-slate-400 hover:text-purple-600 dark:hover:text-purple-400 transition-colors underline'">
        </app-privacy-link>
      </div>
      
      <!-- Back to Landing -->
      <div>
        <a href="/landing" class="inline-flex items-center text-sm font-mono text-slate-500 dark:text-slate-400 hover:text-purple-600 dark:hover:text-purple-400 transition-colors">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
          </svg>
          Volver al inicio
        </a>
      </div>
    </div>
  </div>
</div>